import { BracketTree } from './TournamentBracketTree'
import { TournamentDoubleElimView } from './TournamentDoubleElimView'
import { TournamentRoundRobinView } from './TournamentRoundRobinView'
import { TournamentGroupStageView } from './TournamentGroupStageView'
import type { BracketMatch, StageView } from './types'

interface TournamentStageViewProps {
  stage?: StageView | null
  /** Result launching / follow-along: called when a tappable match is clicked.
   * Omit for a purely static view. */
  onMatchTap?: (match: BracketMatch) => void
}

/**
 * Read-only renderer for a stage: given a `StageView`, it picks the right shape
 * (single/double elimination, round robin, group stage). Shared by the arena's
 * Chave overview and the public follow-along page, so every consumer supports
 * every format — including new ones — without repeating the dispatch.
 *
 * Interactive draw editing (tap-to-swap seeds) is a separate concern and stays
 * in the wizard, which drives the components directly.
 */
export function TournamentStageView({ stage, onMatchTap }: TournamentStageViewProps) {
  if (!stage) return null
  if (stage.bracket) {
    return (
      <BracketTree plan={stage.bracket} interactive={false} selected={null} onTap={() => {}} onMatchTap={onMatchTap} />
    )
  }
  if (stage.doubleElimination) {
    return (
      <TournamentDoubleElimView
        plan={stage.doubleElimination}
        interactive={false}
        selected={null}
        onTap={() => {}}
        onMatchTap={onMatchTap}
      />
    )
  }
  if (stage.roundRobin) {
    return <TournamentRoundRobinView plan={stage.roundRobin} onMatchTap={onMatchTap} />
  }
  if (stage.groupStage) {
    return <TournamentGroupStageView plan={stage.groupStage} onMatchTap={onMatchTap} />
  }
  return null
}
